import React, { useEffect, useState } from "react"
import axios from "axios"
import { Modal, Button, message } from "antd"
import { QRCodeCanvas } from "qrcode.react"
import { MainActions, AuthActions } from "redux-store/models"
import { connect } from "react-redux"

import OtpInput from "../adminModals/DepositoModal/OtpInput"
import { endpoint, skin } from "../../../config/api"

const TwoFactorSetupModal = ({
  open,
  onOpenChange,
  accountInfo,
  required = false,
  onSuccess,
}) => {
  const [step, setStep] = useState("start")

  const [setupOtp, setSetupOtp] = useState("")
  const [otpInput, setOtpInput] = useState(false)

  const [secret, setSecret] = useState("")
  const [qrUrl, setQrUrl] = useState("")

  const [otp, setOtp] = useState("")

  const [loading, setLoading] = useState(false)

  const token = accountInfo?.token

  const cleanOtpAuthUrl = qrUrl.replace(/=+(&|$)/, "$1")

  const resetState = () => {
    setStep("start")
    setOtpInput(false)

    setSetupOtp("")
    setOtp("")

    setSecret("")
    setQrUrl("")

    setLoading(false)
  }

  useEffect(() => {
    if (!open) {
      return
    }

    const shouldFocus = (step === "start" && otpInput) || step === "confirm"

    if (!shouldFocus) {
      return
    }

    const timer = setTimeout(() => {
      const input = document.querySelector("input[data-input-otp]")

      if (input) {
        input.focus()
      }
    }, 150)

    return () => clearTimeout(timer)
  }, [open, step, otpInput])

  const setupTwoFactor = async (oneTimePassword) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    }

    try {
      const response = await axios.post(
        `${endpoint}users/two-factor/setup`,
        {
          one_time_password: oneTimePassword,
          ...skin,
        },
        {
          headers,
        },
      )

      return {
        success: response.status >= 200 && response.status < 300,
        data: response.data,
      }
    } catch (error) {
      return {
        success: false,
        data: error?.response?.data || {
          message: "Impossibile configurare 2FA",
        },
      }
    }
  }

  /*
   * Confirm 2FA
   */
  const confirmTwoFactor = async (totpCode) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    }

    try {
      const response = await axios.post(
        `${endpoint}users/two-factor/confirm`,
        {
          totp_code: totpCode,
          ...skin,
        },
        {
          headers,
        },
      )

      return {
        success: response.status >= 200 && response.status < 300,
        data: response.data,
      }
    } catch (error) {
      return {
        success: false,
        data: error?.response?.data || {
          message: "Errore durante la verifica del codice.",
        },
      }
    }
  }

  const handleSetupTwoFactor = async () => {
    if (loading) {
      return
    }

    setLoading(true)

    try {
      const result = await setupTwoFactor(otpInput ? setupOtp : undefined)

      if (!result.success && result.data?.errors?.one_time_password) {
        setOtpInput(true)

        return
      }

      if (result.success && result.data?.code === 200) {
        setSecret(result.data.secret || "")
        setQrUrl(result.data.otpauth_url || "")

        setOtpInput(false)
        setSetupOtp("")

        setStep("confirm")

        return
      }

      message.error(result.data?.message || "Impossibile configurare 2FA")
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Impossibile iniziare configurazione 2FA",
      )
    } finally {
      setLoading(false)
    }
  }

  const handleConfirmTwoFactor = async () => {
    if (otp.length !== 6 || loading) {
      return
    }

    setLoading(true)

    try {
      const result = await confirmTwoFactor(otp)

      console.log("CONFIRM 2FA RESULT:", result)

      if (result.success && result.data?.code === 200) {
        message.success("Google Authenticator è stato configurato correttamente.")

        resetState()

        if (onSuccess) {
          onSuccess()
        }

      
        if (!required) {
          onOpenChange(false)
        }

        return
      }

      message.error(result.data?.message || "Il codice OTP inserito non è corretto.")
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Errore durante la verifica del codice.",
      )
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (loading) {
      return
    }

    if (step === "start" && otpInput && setupOtp.length === 6) {
      handleSetupTwoFactor()
      return
    }

    if (step === "confirm" && otp.length === 6) {
      handleConfirmTwoFactor()
    }
  }

  const handleClose = () => {
    if (required) {
      return
    }

    resetState()
    onOpenChange(false)
  }

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      footer={null}
      centered
      closable={!required}
      maskClosable={!required}
      width={450}
      title={
        <div
          style={{
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          Abilita autenticazione a due fattori
          <div
            style={{
              marginTop: 4,
              fontSize: 13,
              fontWeight: 400,
              color: "#8c8c8c",
            }}
          >
            Proteggi il tuo account con Google Authenticator.
          </div>
        </div>
      }
    >
      {step === "start" && !otpInput && (
        <div>
          <p
            style={{
              fontSize: 14,
              color: "#595959",
              marginBottom: 20,
            }}
          >
            Genera il QR code e aggiungilo alla tua app Google Authenticator.
          </p>

          <Button
            type="primary"
            block
            loading={loading}
            onClick={handleSetupTwoFactor}
          >
            Genera QR Code
          </Button>
        </div>
      )}

      {step === "start" && otpInput && (
        <form onSubmit={handleSubmit}>
          <p
            style={{
              fontSize: 14,
              marginBottom: 24,
            }}
          >
            Per continuare, inserisci il codice OTP attualmente utilizzato per il tuo
            account.
          </p>

          <div
            style={{
              marginBottom: 24,
            }}
          >
            <p
              style={{
                fontSize: 14,
                marginBottom: 10,
              }}
            >
              Codice OTP
            </p>

            <OtpInput
              value={setupOtp}
              onChange={(value) => {
                setSetupOtp(value)
              }}
              disabled={loading}
              length={6}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            block
            disabled={setupOtp.length !== 6}
            loading={loading}
          >
            Conferma
          </Button>
        </form>
      )}

      {step === "confirm" && (
        <form onSubmit={handleSubmit}>
          <p
            style={{
              fontSize: 14,
              marginBottom: 16,
            }}
          >
            Scansiona il QR code con Google Authenticator e inserisci il codice
            generato.
          </p>

          {qrUrl && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "16px 0 24px",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: 16,
                  borderRadius: 8,
                }}
              >
                <QRCodeCanvas value={cleanOtpAuthUrl} size={200} level="H" />
              </div>
            </div>
          )}

          <div
            style={{
              marginBottom: 24,
            }}
          >
            <p
              style={{
                fontSize: 14,
                marginBottom: 10,
              }}
            >
              Codice OTP
            </p>

            <OtpInput
              value={otp}
              onChange={(value) => {
                setOtp(value)
              }}
              disabled={loading}
              length={6}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            block
            disabled={otp.length !== 6}
            loading={loading}
          >
            Conferma
          </Button>

          <div
            style={{
              marginTop: 20,
            }}
          >
            <p
              style={{
                fontSize: 12,
                color: "#8c8c8c",
                marginBottom: 6,
              }}
            >
              Se non puoi scansionare il QR code, usa manualmente questo codice:
            </p>

            <p
              style={{
                fontSize: 12,
                color: "#8c8c8c",
                wordBreak: "break-all",
                fontFamily: "monospace",
                margin: 0,
              }}
            >
              {secret}
            </p>
          </div>
        </form>
      )}
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  accountInfo: state.auth.accountInfo,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  TwoFactorSetupModal,
)
